// Port of api/fuel/app/classes/controller/api/monty/custom/rename/create.php
import DB from 'offline/db'
import CustomRename from 'offline/model/custom/rename'
import { currentUser, invalid, persist, unauthorised, touchUser } from '../shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return unauthorised()

	var data = params.data || {}
	var gameId = parseInt(data.game, 10) || 0
	var text = (data.text || '').trim()
	var public_ = parseInt(data.public || 0, 10) ? 1 : 0

	if (!gameId || !text) return invalid()

	var rename = CustomRename.record({
		where: {
			user_id: user.get_id(),
			game_id: gameId
		}
	})

	if (rename) {
		DB.run('UPDATE custom_rename SET custom_rename_public = ?, custom_rename_text = ? WHERE custom_rename_id = ?', [
			public_,
			text,
			rename.get_id()
		])
	} else {
		DB.run('INSERT INTO custom_rename (user_id, game_id, collection_id, custom_rename_text, custom_rename_public, custom_rename_context) VALUES (?, ?, ?, ?, ?, ?)', [
			user.get_id(),
			gameId,
			0,
			text,
			public_,
			0
		])
	}

	touchUser(user)

	return persist({
		id: rename ? rename.get_id() : DB.scalar('SELECT last_insert_rowid()'),
		game: gameId,
		context: 0,
		public: public_,
		text: text
	})
}
